import Repository from "@shared/services/api/abstracts/Repository";
import { AuthCsrfSerializer } from "./serializer-types";

export class AuthCsrfRepository extends Repository<AuthCsrfSerializer> {
  public readonly repositoryName = "AuthCsrfRepository";

  public readonly endpoint = "api/return-csrf-cookie";
}
